import { observer } from "mobx-react";
import type React from "react";

import { buildUrlWithPathParams } from "_helpers/utils/urlBuilder";
import { ExamStatusTag } from "components/ExamStatusTag";
import { TEST_PAGE_ROUTES } from "constants/routes";
import type { DiagnosticTestPagePathParams } from "models/path/path-params";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import type { DiagnosticTestListItemProps } from "./DiagnosticTestListItem.model";
import {
  StyledDiagnosticTestItemCard,
  StyledPanelRightHeader,
} from "./DiagnosticTestListItem.styled";

export const DiagnosticTestListItem: React.FC<DiagnosticTestListItemProps> = observer(
  ({ item, title = "", testId, status }) => {
    const { productId, moduleId, groupId } = useParams() as unknown as DiagnosticTestPagePathParams;
    const navigate = useNavigate();
    const { t } = useTranslation("diagnostic-test");

    const hasVisibleStatusTag = !!ExamStatusTag({ status });

    return (
      <StyledDiagnosticTestItemCard
        onClickButton={() =>
          navigate(
            buildUrlWithPathParams(TEST_PAGE_ROUTES.DIAGNOSTIC_TEST_DETAILS, {
              productId,
              moduleId,
              groupId,
              testId,
            }),
          )
        }
        title={title}
        dataCy={`diagnostic-test-list-item-${item.id}`}
        buttonLabel={t("diagnosticTestList.gotoTestButton", "Go to test")}
        circleComponent={
          <StyledPanelRightHeader>
            {hasVisibleStatusTag ? <ExamStatusTag status={status} /> : <div />}
          </StyledPanelRightHeader>
        }
      />
    );
  },
);
